import styles from './ErenBlaze.module.css';
import Background from "@/commons/pages/borders/background/Background";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import React from "react";

import banner from "@/commons/resources/images/erenblaze/banner.png";
import scritta from "@/commons/resources/images/erenblaze/scritta.png";
import SimoneCaglioni from "@/commons/resources/images/erenblaze/SimoneCaglioni.png";

const ErenBlaze = () => {

    document.title = "EBLCraft - ErenBlaze"

    return (
        <>
            <Background/>
            <div className={styles.erenblaze__body}>
                <Header/>
                <div className={styles.erenblaze__page}>
                    <img src={banner} alt={"ErenBlaze Banner"}/>

                    <div className={styles.erenblaze__content}>
                        <div className={styles.erenblaze__scritta}><img src={scritta} alt={"Scritta"}/></div>
                        <div className={styles.erenblaze__section}>
                            <img src={SimoneCaglioni} alt={"Simone Caglioni"}/>
                            <div>
                                <h2 className={styles.erenblaze__section__title}>MI PRESENTO</h2>
                                <span className={styles.erenblaze__section__text}>
                                    Mi chiamo Simone Caglioni, ma online sono meglio conosciuto come ErenBlaze,
                                    uno youtuber e content creator specializzato in contenuti legati al mondo dei videogiochi.
                                    Il mio canale YouTube è stato fondato nel maggio 2013 e, da allora, ho raggiunto un pubblico di
                                    oltre 827.000 iscritti e accumulato più di 484 milioni di visualizzazioni complessive.
                                    La mia passione per il gaming e la creazione di contenuti mi ha portato a dedicare la maggior
                                    parte del mio tempo a realizzare video che spaziano da gameplay e recensioni a guide dettagliate per
                                    aiutare la mia community. Il nome "ErenBlaze" deriva dalle mie due grandi passioni: Eren,
                                    protagonista dell'anime Attack on Titan, e Blaze, una delle creature ostili di Minecraft,
                                    il gioco che ha segnato l'inizio della mia carriera su YouTube.
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
                <Footer/>
            </div>
        </>
    );

}

export default ErenBlaze;